export enum CoreHeaderMenusMask {
  OFF = 0,
  NOTIFICATIONS = 1 << 0,
  TOOLS = 1 << 1,
  SERVICES = 1 << 2,
  USER = 1 << 3,
}
